/**
 * Centralized registry of `data-tour` attribute keys used by the onboarding tour.
 *
 * If you remove an element annotated with one of these, the tour overlay will
 * fall back to a centred tooltip (no spotlight) — see TourOverlayComponent.
 * That keeps the tour from breaking, but the relevant step loses its visual
 * anchor; pick a new element and move the attribute over.
 *
 * Step → anchor mapping lives in onboarding-tour.service.ts (TOUR_STEPS).
 */
export const TOUR_ANCHORS = {
  HEATMAP: 'heatmap',
  SIDEBAR_TAB_ALL: 'sidebar-tab-all',
  SIDEBAR_TAB_SEARCH: 'sidebar-tab-search',
  THRESHOLD_SLIDER: 'threshold-slider',
  HIGHLIGHT_CARD_FIRST: 'highlight-card-first',
  /** Container for the whole highlights list — used to spotlight the entire sidebar area
   *  on steps where contents change (slider, AI). */
  HIGHLIGHTS_LIST: 'highlights-list',
  /** Marks every ai-deep-dive card so step 8 can spotlight all of them. Multiple matches. */
  HIGHLIGHT_CARD_AI: 'highlight-card-ai',
  /** Action buttons on the highlights card (pin / delete) — anchors with hotkey hints in step 9. */
  CARD_BTN_PIN: 'card-btn-pin',
  CARD_BTN_TRASH: 'card-btn-trash',
  SEARCH_INPUT: 'search-input',
  SEARCH_BUTTON: 'search-button',
  SEARCH_RESULT_BADGE: 'search-result-badge',
  /** Floating samples popover that opens after clicking a search-result amber badge. Dynamically rendered. */
  SEARCH_SAMPLES_POPOVER: 'search-samples-popover',
  BTN_QUICK_AI: 'btn-quick-ai',
  BTN_DEEP_AI: 'btn-deep-ai',
  BTN_DOWNLOAD_CLIP: 'btn-download-clip',
  PLAYER: 'player',
} as const;

export type TourAnchor = typeof TOUR_ANCHORS[keyof typeof TOUR_ANCHORS];
